import { render } from "./ServiceGroup.vue?vue&type=template&id=b8ea4d28"
import script from "./ServiceGroup.vue?vue&type=script&lang=js"
export * from "./ServiceGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__